import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { forwardRef } from "react";

import { cn } from "@/lib/utils";

import CheckedSquare from "./CheckedSquare";
import UncheckedSquare from "./UncheckedSquare";

interface Props
  extends React.ComponentPropsWithoutRef<
    typeof DropdownMenuPrimitive.CheckboxItem
  > {
  indicatorColor?: string;
}

const DropdownMenuCheckboxItemWithStatus = forwardRef<
  React.ElementRef<typeof DropdownMenuPrimitive.CheckboxItem>,
  Props
>(
  (
    {
      className,
      children,
      checked = false,
      indicatorColor = "#6B7280",
      ...props
    },
    ref
  ) => (
    <DropdownMenuPrimitive.CheckboxItem
      ref={ref}
      className={cn(
        "relative flex cursor-default select-none items-center gap-[10px] rounded-sm py-1.5 pr-5 pl-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        className
      )}
      checked={checked}
      {...props}
    >
      <div
        className="w-[7px] h-[7px] rounded-xl"
        style={{ backgroundColor: indicatorColor }}
      ></div>
      {checked ? <CheckedSquare /> : <UncheckedSquare />}
      {children}
    </DropdownMenuPrimitive.CheckboxItem>
  )
);

DropdownMenuCheckboxItemWithStatus.displayName =
  "DropdownMenuCheckboxItemNoIndicator";

export default DropdownMenuCheckboxItemWithStatus;
